import { ServicePackagesTable } from "@/admin/services/ServicePackagesTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/service_packages")({
    component: ServicePackagesTable,
});
